import { ToastContainer as AuthToastContainer } from '@lovoldsystem/authorization.client'
import { queryClient } from '@lovoldsystem/core.client'
import { muiTheme, ThemeProvider as UIThemeProvider } from '@lovoldsystem/ui'
import { ThemeProvider } from '@mui/material'
import { useEffect } from 'react'
import { QueryClientProvider } from 'react-query'
import { BrowserRouter } from 'react-router-dom'
import { Theme, ToastContainer, ToastPosition } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { NavigationProvider } from './context/NavigationContext'
import { MainRouter } from './MainRouter'
import { GlobalStyled } from './styles/globalPaddingStyles'
import { caching } from './utils'

function App() {
  useEffect(() => {
    caching()
  }, [])

  const toastProps = {
    hideProgressBar: false,
    newestOnTop: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    autoClose: 5000,
    theme: 'light' as Theme,
    position: 'top-right' as ToastPosition,
  }

  return (
    <>
      <QueryClientProvider client={queryClient} contextSharing={true}>
        <GlobalStyled>
          <BrowserRouter>
            <NavigationProvider>
              <UIThemeProvider>
                <ThemeProvider theme={muiTheme.muiTheme}>
                  <div id="dialog-root"></div>
                  <MainRouter />
                  <AuthToastContainer {...toastProps} />
                  <ToastContainer {...toastProps} />
                </ThemeProvider>
              </UIThemeProvider>
            </NavigationProvider>
          </BrowserRouter>
        </GlobalStyled>
      </QueryClientProvider>
    </>
  )
}

export default App
